import { Controller } from "@hotwired/stimulus"

// Select all / none over a list of checkboxes, with a count of what is ticked.
export default class extends Controller {
  static targets = ["box", "count", "all", "none"]

  connect() {
    this.report()
  }

  all() { this.set(true) }
  none() { this.set(false) }

  set(checked) {
    this.boxTargets.forEach((box) => { box.checked = checked })
    this.report()
  }

  report() {
    const ticked = this.boxTargets.filter((box) => box.checked).length

    if (this.hasCountTarget) {
      this.countTarget.textContent = ticked === this.boxTargets.length ? "All ticked" : `${ticked} of ${this.boxTargets.length} ticked`
    }
    if (this.hasAllTarget) this.allTarget.hidden = ticked === this.boxTargets.length
    if (this.hasNoneTarget) this.noneTarget.hidden = ticked === 0
  }
}
